/**
 * Project : workspace
 * File    : CreateTagScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.tag.create

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel


import com.parmartechnologies.commerce.feature.inventory.viewModel.tag.TagViewModel
import common.asset.ImageAsset
import component.CustomDefaultBtn
import component.ErrorSuggestion
import component.input.CustomTextField
import component.input.TextInputField
import component.loader.AppLoader
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import theme.ThemeColor

/**
 * Represents the create tag screen class.
 */

class CreateTagScreen {

    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val viewModel = TagViewModel(business = myBusiness.value)
        var name by remember {
            mutableStateOf(TextFieldValue(""))
        }
        val description = remember { mutableStateOf("") }
        val nameErrorState = remember { mutableStateOf(false) }
        Column(
            modifier = Modifier.fillMaxSize()
                .background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(title = localization().tagMenu.tagCreate, onBackPress = {
                AppNavigator.shared().goBack()
            })
            AppLoader(viewModel)
            Spacer(modifier = Modifier.height(50.dp))
            CustomTextField(
                value = name.text,
                placeholder = localization().tagMenu.tagNamePlaceholder,
                trailingIcon = ImageAsset.person,
                label = localization().tagMenu.tagName,
                errorState = nameErrorState.value,
                keyboardType = KeyboardType.Email,
                visualTransformation = VisualTransformation.None
            ) { newEmail ->
                name = newEmail
            }

            Spacer(modifier = Modifier.height(10.dp))
            if (nameErrorState.value) {
                ErrorSuggestion("Please enter valid Name")
            }

            TextInputField(
                title = "Description",
                "Enter Description",
                description.value
            ) {
                description.value = it
            }

            CustomDefaultBtn(shapeSize = 50f, btnText = localization().button.saveButton) {
                val nameErrorState = name.text.length < 4
                if (nameErrorState) {

                } else {
                    viewModel.createNewTag(name.text, description.value) {
                        AppNavigator.shared().goBack()
                    }
                }
            }
        }
    }
}